module.exports = __webpack_public_path__ + "img/start.4e2ef143.svg";